import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { RoleForm } from '@/components/forms/RoleForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateRolePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/user-management/roles')
  }

  const handleCancel = () => {
    navigate('/user-management/roles')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create New Role</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Create a new role and assign permissions
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <RoleForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


